import * as React from 'react';

function SvgMarine48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M43 35.5L24 32.5C24 32.5 26 25.624 26 18C26 8.25 22.5 2 22.5 2C22.5 2 44 10.9878 43 35.5Z'
        stroke='currentColor'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19 39V2H13L15 3.94737L13 5.89474H19'
        stroke='currentColor'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M47 39.0122H1V41.0122C1 43 5.686 47.0122 9 47.0122H32.5C37.044 47.0122 44.284 44.4442 46.316 40.3782L47 39.0122Z'
        stroke='currentColor'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 15.0122L14 33L3 35.0122L15 15.0122Z'
        stroke='currentColor'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default SvgMarine48;
